/**
 * Given a string, return a slug-safe version of it. Based on
 * [Django's slugify function](https://docs.djangoproject.com/en/4.2/ref/utils#django.utils.text.slugify).
 *
 * See
 * - https://en.wikipedia.org/wiki/Clean_URL#Slug
 * - https://en.wikipedia.org/wiki/Slug_(publishing)
 */
export const slugify = (value: string): string => {
    return value
        .normalize("NFKD")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[-\s]+/g, "-");
};
